import { cn } from "@/lib/utils";

/**
 * The BluMarbl wordmark. Wrapped in a light chip because its letterforms mix
 * cyan fill with default-black fill — the black strokes vanish on the app's
 * dark surfaces (the Sidebar is always dark) without a light background.
 */
export function BrandLogo({
  className,
  size = "sm",
}: {
  className?: string;
  size?: "sm" | "lg";
}) {
  return (
    <span
      className={cn(
        "inline-flex w-fit shrink-0 items-center self-start rounded-md bg-white px-2 py-1",
        className,
      )}
    >
      <img
        src="/BluMarbl-logo-white-bg_v2.svg"
        alt="BluMarbl"
        width={790}
        height={215}
        className={cn("w-auto", size === "lg" ? "h-8" : "h-4")}
      />
    </span>
  );
}
